import { render, staticRenderFns } from "./TheAttachment.vue?vue&type=template&id=e2b8dca8&scoped=true&"
import script from "./TheAttachment.vue?vue&type=script&lang=js&"
export * from "./TheAttachment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2b8dca8",
  null
  
)

export default component.exports